import ru from "@rmp/id/plugins/i18n/locales/ru";

export default {
	ru
};
